'use client'
import Image from 'next/image'
import RALogo from '/public/images/ra-logo.png'

const ReclameAqui = () => {
  return (
    <a
      style={{ borderRadius: 8, overflow: 'hidden' }}
      href="https://www.reclameaqui.com.br/empresa/lapa-team/?utm_source=referral&utm_medium=embbed&utm_campaign=ra_verificada&utm_term=horizontal"
      target="_blank"
    >
      <Image
        src={RALogo}
        height={44}
        width={146}
        alt="Selo Reclame Aqui"
        title="Selo Reclame Aqui"
      />
    </a>
  )
}

export default ReclameAqui
